import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let refreshing = null;
const AUTH_PATHS = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/me"];

// On 401 for a protected call: refresh the session once (httpOnly refresh cookie) and retry; otherwise hand back to the login page.
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const { config, response } = err;
    if (response?.status !== 401 || !config || config._retried || AUTH_PATHS.some((p) => (config.url || "").includes(p))) throw err;
    config._retried = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      await refreshing;
      return api(config);
    } catch {
      window.dispatchEvent(new CustomEvent("auth:expired"));
      throw err;
    }
  },
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (err?.response?.status === 401) return "Your session has expired — please sign in again. Unsaved text stays in the form until you leave the page.";
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.missing ? `${detail.message}: ${detail.missing.join(", ")}` : detail.message;
  return String(detail);
}

export default api;
